import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select, { createFilter } from 'react-select';
import './AddThermostat.css';
import { EllipsisLoader } from '../../../EllipsisLoader';
import { ThermostatActions } from '../../../../store';
import { PrimaryButton } from '../../../PrimaryButton';

const validDirections = [
  {
    value: 'north',
    label: 'N',
  },
  {
    value: 'west',
    label: 'W',
  },
  {
    value: 'east',
    label: 'E',
  },
  {
    value: 'south',
    label: 'S',
  },
  {
    value: 'south_west',
    label: 'SW',
  },
  {
    value: 'south_east',
    label: 'SE',
  },
  {
    value: 'north_west',
    label: 'NW',
  },
  {
    value: 'north_east',
    label: 'NE',
  },
];

export class AddThermostat extends Component {
  generatedValidFloors = () => {
    const { number_of_floors: numberOfFloors } = this.props.selectedBuilding;
    const validFloors = [];

    for (let i = 1; i <= numberOfFloors; i += 1) {
      validFloors.push({
        value: i,
        label: i,
      });
    }

    return validFloors;
  };

  register = async () => {
    const {
      selectedBuilding: { slug },
      onPinGenerationClick,
      floor: { value: floorValue },
      suite,
      direction: { value: directionValue },
      register,
    } = this.props;

    const result = await register(slug, floorValue, suite, directionValue).catch(() => 'error');

    if (!result || result === 'error' || result.type === 'THERMOSTAT_CONSTANTS.THERMOSTATS_ERROR') {
      return;
    }

    onPinGenerationClick();
  };

  render() {
    const {
      floor,
      suite,
      direction,
      isRegistering,
      selectedBuilding: { name },
      thermostatError,
      onFloorChange,
      onSuiteChange,
      onDirectionChange,
    } = this.props;

    /* istanbul ignore next */
    const customStyles = {
      control: (styles) => ({
        ...styles,
        height: '4rem',
        border: '1px solid #abadae',
        marginTop: '0.4rem',
        boxShadow: '0 1px 0 0 rgba(46, 50, 53, 0.1)',
        fontWeight: '400',
        textAlign: 'left',
      }),
      option: (provided) => ({
        ...provided,
        fontWeight: '400',
        textAlign: 'left',
      }),
    };

    const filterConfig = {
      ignoreCase: true,
      matchFrom: 'start',
    };

    return (
      <div className="add-thermostat">
        <div className="add-thermostat__text">{name}</div>
        <div className="add-thermostat__text">Enter the thermostat&apos;s zone:</div>
        <div className="add-thermostat__zone-wrapper">
          <div className="add-thermostat__zone-section">
            <label className="add-thermostat__zone-text-input" htmlFor="floor-select">
              Floor:
              <div className="add-thermostat__zone-input--floor">
                <Select
                  id="floor-select"
                  name="floor-select"
                  value={floor}
                  options={this.generatedValidFloors()}
                  styles={customStyles}
                  className="add-thermostat__zone-input-dropdown"
                  onChange={onFloorChange}
                  filterOption={createFilter(filterConfig)}
                />
              </div>
            </label>
          </div>
          <div className="add-thermostat__zone-section">
            <label className="add-thermostat__zone-text-input" htmlFor="suite-input">
              Suite number:
              <input
                type="text"
                id="suite-input"
                className="add-thermostat__zone-input--suite"
                name="suite"
                value={suite}
                onChange={onSuiteChange}
                maxLength="8"
              />
            </label>
          </div>
          <div className="add-thermostat__zone-section">
            <label className="add-thermostat__zone-text-input" htmlFor="direction-select">
              Direction:
              <div className="add-thermostat__zone-input--direction">
                <Select
                  id="direction-select"
                  classNamePrefix="direction"
                  name="direction-select"
                  value={direction}
                  options={validDirections}
                  styles={customStyles}
                  className="add-thermostat__zone-input-dropdown"
                  onChange={onDirectionChange}
                  filterOption={createFilter(filterConfig)}
                />
              </div>
            </label>
          </div>
        </div>
        <div className="add-thermostat__button-wrapper">
          <PrimaryButton
            isDisabled={!(floor && suite && direction)}
            label="Generate Pin"
            onClick={() => this.register()}
            fullWidth={true}
          />
        </div>
        <div
          className="add-thermostat__loading-message-div"
          style={isRegistering || thermostatError ? {} : { visibility: 'hidden' }}
        >
          {isRegistering ? <EllipsisLoader text="Registering" /> : null}
          {thermostatError ? <div className="add-thermostat__modal-error-message">{thermostatError}</div> : null}
        </div>
      </div>
    );
  }
}

AddThermostat.propTypes = {
  floor: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  suite: PropTypes.string,
  direction: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  onFloorChange: PropTypes.func.isRequired,
  onSuiteChange: PropTypes.func.isRequired,
  onDirectionChange: PropTypes.func.isRequired,
  onPinGenerationClick: PropTypes.func.isRequired,
  selectedBuilding: PropTypes.shape({
    address_line_1: PropTypes.string,
    address_line_2: PropTypes.string,
    age: PropTypes.number,
    baseline_end_datetime: PropTypes.string,
    baseline_start_datetime: PropTypes.string,
    city: PropTypes.shape({
      alternate_names: PropTypes.string,
      country: PropTypes.number,
      display_name: PropTypes.string,
      feature_code: PropTypes.number,
      geoname_id: PropTypes.number,
      id: PropTypes.number,
      latitude: PropTypes.number,
      longitude: PropTypes.number,
      name: PropTypes.string,
      name_ascii: PropTypes.string,
      population: PropTypes.number,
      region: PropTypes.number,
      search_names: PropTypes.string,
      slug: PropTypes.string,
      timezone: PropTypes.string,
    }),
    country: PropTypes.shape({
      alternate_names: PropTypes.string,
      code2: PropTypes.number,
      code3: PropTypes.number,
      continent: PropTypes.string,
      geoname_id: PropTypes.number,
      id: PropTypes.number,
      name: PropTypes.string,
      name_ascii: PropTypes.string,
      phone: PropTypes.number,
      slug: PropTypes.string,
      tld: PropTypes.string,
    }),
    fiscal_year_end_day: PropTypes.number,
    fiscal_year_end_month: PropTypes.number,
    fiscal_year_start_day: PropTypes.number,
    fiscal_year_start_month: PropTypes.number,
    id: PropTypes.number,
    image: PropTypes.string,
    name: PropTypes.string,
    number_of_floors: PropTypes.number,
    number_of_units: PropTypes.number,
    postal_code: PropTypes.string,
    province: PropTypes.shape({
      alternate_names: PropTypes.string,
      country: PropTypes.number,
      display_name: PropTypes.string,
      geoname_code: PropTypes.number,
      geoname_id: PropTypes.number,
      id: PropTypes.number,
      name: PropTypes.string,
      name_ascii: PropTypes.string,
      slug: PropTypes.string,
    }),
    reporting_start_datetime: PropTypes.string,
    slug: PropTypes.string,
    utilities: PropTypes.array,
  }).isRequired,
  thermostatError: PropTypes.string,
  register: PropTypes.func.isRequired,
  isRegistering: PropTypes.bool.isRequired,
};

AddThermostat.defaultProps = {
  thermostatError: undefined,
  floor: { value: '', label: '' },
  suite: '',
  direction: { value: '', label: '' },
};

export function mapStateToProps(state) {
  return {
    selectedBuilding: state.buildingReducer.selectedBuilding,
    thermostatError: state.thermostatReducer.error,
    isRegistering: state.thermostatReducer.isRegistering,
  };
}

const mapDispatchToProps = {
  register: ThermostatActions.register,
};

export const ConnectedAddThermostat = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddThermostat);
